/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type ActionSource = (typeof ActionSource)[keyof typeof ActionSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionSource = {
  MANUAL: "MANUAL",
  RULE: "RULE",
} as const;
